import React, { memo } from 'react';
import { splitEvery } from 'ramda';
import { branch, renderNothing, compose } from 'recompose';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { Icon } from 'js/components/common/Icon';

import cls, { mergeClassNames } from 'js/utils/classNameBuilder.util';
import withRegistrationCountDown from '../../common/CountDown/withRegistrationCountDown';
import RaceProperty from '../../common/RaceProperty';
import withListItems from './withRaceInfoItems';
import style from './index.scss';

const PureIcon = memo(Icon);

export const RaceInfoItem = ({ className = '', classNames = {}, icon, label, value }) => (
    <div className={`${style.item} ${className}`}>
        {icon && <PureIcon className={cls(['icon'], style, classNames)} type={icon} />}
        <RaceProperty
            className={cls(['text', 'tallText'], style, classNames)}
            classNames={mergeClassNames(['label', 'value'], style, classNames)}
            label={label}
            value={value}
        />
    </div>
);

export const RegistrationCountDown = withRegistrationCountDown(RaceInfoItem);

export const RaceInfoTable = ({ items, showIcon = false }) => {
    const rows = splitEvery(2, items);
    return (
        <table className={style.infoTable}>
            <tbody>
            {
                rows.map((item, index) => (
                    <tr key={index}>
                        {
                            item.map(({ name, ...rest }, index2) => (
                                <td className={style.infoTableCell} key={index2}>
                                    {
                                        name === 'registrationCountDown'
                                            ? <RegistrationCountDown className={showIcon ? '' : style.noIcon}
                                                                     key={name} {...rest} />
                                            : <RaceInfoItem className={showIcon ? '' : style.noIcon}
                                                            key={name} {...rest} />
                                    }
                                </td>
                            ))
                        }
                    </tr>
                ))
            }
            </tbody>
        </table>
    );
};

export default compose(
    withTranslations,
    withListItems,
    branch(
        ({ items }) => !items || !items.length,
        renderNothing
    )
)(RaceInfoTable);
